import { render, staticRenderFns } from "./FttbAddons.vue?vue&type=template&id=835bbd60&scoped=true&"
import script from "./FttbAddons.vue?vue&type=script&lang=js&"
export * from "./FttbAddons.vue?vue&type=script&lang=js&"
import style0 from "./FttbAddons.vue?vue&type=style&index=0&id=835bbd60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835bbd60",
  null
  
)

export default component.exports